// extracted by mini-css-extract-plugin
export default {"total-area":"total-area_total-area__vgsNL","name":"total-area_name__E+i0P","count":"total-area_count__OAiSm"};